import {
  makeFieldSchemaFromZod,
  scaffolderPlugin,
} from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react'; // eslint-disable-line
import { Box, Input } from '@material-ui/core';
import type { FieldValidation, FormContextType } from '@rjsf/utils';
// zod/v3: makeFieldSchemaFromZod is typed against zod's v3 ZodType, whose generics
// differ from v4's. The root zod is v4.
import { z } from 'zod/v3'; // eslint-disable-line
import './styles.css';

function isRegexValid(regex: string) {
  try {
    RegExp(regex);
    return true;
  } catch (e) {
    return false;
  }
}

const TextFieldWithOptionsFieldSchema = makeFieldSchemaFromZod(
  z.object({
    value: z.string(),
    fullValue: z.string(),
  }),
  z.object({
    prefix: z.string(),
    sufix: z.string(),
  }),
);

type TextFieldWithOptionsProps = typeof TextFieldWithOptionsFieldSchema.type;
const TextFieldWithOptionsSchema = TextFieldWithOptionsFieldSchema.schema;

const TextFieldWithPrefixAndSufixComponent = (
  props: TextFieldWithOptionsProps,
) => {
  const title = (props.schema.title ?? props.name) + (props.required ? " *" : "");
  const uiOptions = props.uiSchema['ui:options'];
  const prefix = uiOptions?.prefix || '';
  const sufix = uiOptions?.sufix || '';
  const defaultValue =
    props.formData?.value || props.schema.default?.toString() || '';
  return (
    <Box className="sufixprefix-box-main">
      <small>{title}</small>
      <Box className="sufixprefix-box-wrapper">
        {prefix && <Box className="sufixprefix-box-prefix">{prefix}</Box>}
        <Input
          className="sufixprefix-input"
          fullWidth
          placeholder={props.uiSchema['ui:placeholder']}
          aria-describedby="entityName"
          required={props.required}
          defaultValue={defaultValue}
          onChange={e =>
            props.onChange({
              value: e.target?.value.trim(),
              fullValue: prefix + e.target?.value.trim() + sufix,
            })
          }
        />
        {sufix && <Box className="sufixprefix-box-sufix">{sufix}</Box>}
      </Box>
    </Box>
  );
};

export const validator = (
  data: typeof TextFieldWithOptionsFieldSchema.type.formData,
  validation: FieldValidation,
  context: FormContextType,
) => {
  const pattern = context.schema.pattern?.toString();
  if (!pattern || !isRegexValid(pattern)) return;
  const reg = new RegExp(pattern);
  if (!reg.test(data!.value)) {
    validation.addError(`Text should match pattern "${pattern}"`);
  }
};

export const TextFieldWithPrefixAndSufixExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'TextFieldWithPrefixAndSufix',
    component: TextFieldWithPrefixAndSufixComponent,
    schema: TextFieldWithOptionsSchema,
    validation: validator,
  }),
);
